import request from '@/api/request.js';

// 违规公示列表
export const getIllegalPublicityListPage = (data) => {
    return request({
        url: '/cms/adm/illegalPublicity/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 添加违规公示
export const addIllegalPublicity = (data) => {
    return request({
        url: '/cms/adm/illegalPublicity/addIllegalPublicity',
        method: 'post',
        type: 'json',
        data
    })
}

// 删除违规公示
export const delIllegalPublicity = (data) => {
    return request({
        url: '/cms/adm/illegalPublicity/delIllegalPublicity',
        method: 'post',
        data
    })
}